import {
  CortexDecoderProvider,
  CortexReceivingVideo,
} from 'lib/scanner/compatibility'
import { ScanbotReceivingVideo } from 'lib/scanner/scanbot/ScanbotVideo'
import { useRef, useState, useEffect, useCallback } from 'react'
import { ReceivingSingleScanProviderProps } from './ReceivingSingleScanProvider.types'
import { useFlags } from 'launchdarkly-react-client-sdk'

export function WorkflowScanProvider({
  onScan,
  canScan = true,
}: ReceivingSingleScanProviderProps) {
  const isMounted = useRef(true)
  const [currentScan, setCurrentScan] = useState<
    CortexDecoder.CDResult | undefined
  >()
  const flags = useFlags()
  const useScanbotScanner = flags.useScanbotSdk

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  const handleScan = useCallback(
    (newScan: CortexDecoder.CDResult) => {
      if (isMounted.current) {
        setCurrentScan(newScan)
        onScan && onScan(newScan.barcodeData)
      } else if (process.env.REACT_APP_NODE_ENV !== 'production') {
        console.warn('Read a barcode but component was not mounted')
      }
    },
    [onScan]
  )

  return (
    <CortexDecoderProvider
      hasROI={false}
      canScan={canScan}
      onScan={handleScan}
      currentScan={currentScan}
      setCurrentScan={setCurrentScan}
    >
      {useScanbotScanner ? (
        <ScanbotReceivingVideo width="100%" height="100%" />
      ) : (
        <CortexReceivingVideo width="100%" height="100%" />
      )}
    </CortexDecoderProvider>
  )
}
